module.exports = __webpack_public_path__ + "static/media/fifth_north_church5.488bbe03.png";